import { useEffect } from 'react';

export default function useNavigationKeyboard({ canGoBack, canGoForward, goBack, goForward }) {
  useEffect(() => {
    function onKeyDown(e) {
      if (!e.altKey || e.ctrlKey || e.metaKey || e.shiftKey) return;

      if (e.key === 'ArrowLeft' && canGoBack) {
        e.preventDefault();
        goBack();
      } else if (e.key === 'ArrowRight' && canGoForward) {
        e.preventDefault();
        goForward();
      }
    }

    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [canGoBack, canGoForward, goBack, goForward]);
}
